<template>
  <div class="article">
    <header>
      <p>
        Da seguimiento a tus referidos, revisa su estado y cuánto has ganado en giftcards.
      </p>
      <div>
        <span>
          Total de referidos: {{dataSource.total_referrals}}
        </span>
        <a-divider type="vertical" class="divider" />
        <span class="amount-earned">
          Monto ganado: ${{dataSource.total_earned}}
        </span>
      </div>
    </header>
    <referral-program-table-controls
      @openBenefitsModal="handleModalOpen"
      @openRegisterNewBenefit="handleModalRegisterOpen"
      @update="handleSearch"
    />
    <referral-program-table
      class="table-users"
      :dataSource="dataSource.items"
      :pagination="pagination"
      @openRegisterNewBenefit="handleModalRegisterOpen"
      @update="handleSearch"
    />
  </div>
  <ModalBenefitsReferral v-if="isModalVisible" v-model:visible="isModalVisible" @openRegisterNewBenefit="visibleModalRegister = true" />
  <ModalRegisterBenefits v-if="visibleModalRegister" v-model:visible="visibleModalRegister" @update="handleSearch"/>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch, provide } from 'vue';

import ReferralProgramTableControls from "@/app/referralProgram/components/tables/ReferralProgramTableControls.vue";
import ReferralProgramTable from "@/app/referralProgram/components/tables/ReferralProgramTable.vue";
import ModalBenefitsReferral from "@/app/referralProgram/components/modals/ModalBenefitsReferral.vue";
import { useStore } from "vuex";
import ModalRegisterBenefits from '../components/modals/ModalRegisterBenefits.vue';
import { ReferredUser } from '../utils/IReferral';
import { referralService } from '../service/ReferralService';

const store = useStore();
const user = computed(() => store.getters["getDataUser"]);

const isModalVisible = ref(false);
const visibleModalRegister = ref(false);

const dataSource = ref<{ pagination: any; items: ReferredUser[]; total_referrals: number; total_earned: number; }>({ pagination: {}, items: [], total_referrals: 0, total_earned: 0 });
const formFilter = ref({
  search: '',
  state: 0,
});
const currentTablePage = ref(1);
provide('formFilter', formFilter);
provide('currentTablePage', currentTablePage);

const pagination = computed(() => (
  { current: currentTablePage.value, ...dataSource.value.pagination }
));

const coerceBool = (v: unknown) =>
  v === true || v === 'true' || v === 1 || v === '1';

watch(
  user,
  (newUser) => {
    console.log("User changed, updating modal visibility:", newUser);
    if (newUser?.show_referral_banner)
      isModalVisible.value = coerceBool(newUser?.show_referral_banner);
  },
  { immediate: true }
);

const handleModalRegisterOpen = () => {
  visibleModalRegister.value = true;
};

const handleModalOpen = () => {
  isModalVisible.value = true;
};

const handleModalCancel = () => {
  isModalVisible.value = false;
};

const handleSearch = async () => {
  dataSource.value = await referralService.getReferralContent(
    formFilter.value,
    pagination.value
  );
};

onMounted(async () => {
  await handleSearch();
});
</script>

<style lang="sass" scoped>
.table-users
  margin-top: 12px

header
  display: flex
  justify-content: space-between

header
  display: flex
  justify-content: space-between

.divider
  background-color: $gray-6

.amount-earned
  font-weight: 600
</style>
